import { Link } from '@remix-run/react'
import { type Posts } from '#app/routes/wine-journal+/index.tsx'
import { buildLinkPath } from '#app/utils/util.ts'
import { H3, Paragraph } from './typography'
import { Button } from './ui/button'

// const buildLinkPath = (posttype: string, slug: string) => {
// 	switch (posttype) {
// 		case 'Study':
// 			return `/wset-study-blog/${slug}`
// 		case 'Varietals':
// 			return `/grape-varietals/${slug}`
// 		default:
// 			return `/wijn-blog/${slug}`
// 	}
// }

export const Articles = ({ posts }: Posts) => (
	<>
		{posts.length > 0 &&
			posts.map(
				({
					id,
					publishedAt,
					title,
					slug,
					excerpt,
					posttype,
					maincategory,
					thumbnail,
				}) => (
					// <Link
					// 	to={buildLinkPath(posttype, slug)}
					// 	className="item border-[12px] border-solid border-white p-2 shadow-xl transition duration-300 hover:scale-[1.02] hover:cursor-pointer"
					// 	key={id}
					// >
					<div
						className="article item flex flex-col border-[12px] border-solid border-white p-2 shadow-xl transition duration-300 hover:scale-[1.02]"
						key={id}
					>
						<H3 className="mb-4 text-4xl">{title}</H3>
						{thumbnail && (
							<img
								src={thumbnail.image.url}
								alt={thumbnail.thumbnailAltText}
								width={thumbnail.image.width}
								height={thumbnail.image.height}
							/>
						)}
						<Paragraph className="m-6">{excerpt}</Paragraph>
						<Button className="self-end">
							<Link to={buildLinkPath(posttype, slug)}>Read More</Link>
						</Button>
						<div className="flex items-center py-2">
							<Paragraph className="text-xs capitalize italic">
								{publishedAt &&
									new Date(publishedAt).toLocaleString('default', {
										day: 'numeric',
										month: 'long',
										year: 'numeric',
									})}{' '}
								/ {maincategory && maincategory.category}
							</Paragraph>
							<div className="ml-2 flex-grow border-t-2 border-gray-300" />
						</div>
					</div>
					// {/* </Link> */}
				),
			)}
	</>
)
